import { MicrosoftUserSettingsImage } from "./components/microsoft-user-settings-image";
import { SetupSection } from "./components/setup-section";
import { OrderedList } from "./components/styled";
import { type PlatformDetails } from "./platform-details";

export const MicrosoftDetails: PlatformDetails = {
  northbeamDocUrl: "https://docs.northbeam.io/docs/tracking-for-microsoft",
  officialDocUrl: "",
  additionalDetails: [
    {
      title: "What does the integration do?",
      content: `Northbeam natively integrates with the Microsoft Ads API.
        By doing so, we pull all your current and historical Campaigns, Adsets, and Ads from your account, along with a list of useful metrics.
        Notably, we pull impressions, which fuel our view model and unlock our Clicks + Modeled Views attribution model.`,
    },
    {
      title: "Why don’t I need to configure UTMs for Microsoft?",
      content:
        "Sit back and relax! Microsoft UTMs are automatically configured through your integration!",
    },
  ],
};

export const MicrosoftSetup = ({
  connectionContent,
}: {
  connectionContent: React.ReactNode;
}) => (
  <>
    <SetupSection title="Before connecting, please confirm:">
      <OrderedList variant="upper-alpha">
        <div className="inline-table ml-2">
          Your Microsoft Account has "Allow user consent for apps" enabled.
          <br />
          For more guidance see "Configure User Consent Settings" in{" "}
          <a
            href="https://learn.microsoft.com/en-us/entra/identity/enterprise-apps/configure-user-consent?pivots=portal"
            target="_blank"
            rel="noreferrer"
          >
            Microsoft's Documentation.
          </a>
          <div className="my-2">Screenshot for reference:</div>
          <MicrosoftUserSettingsImage />
        </div>
        <>Your Microsoft Account is a Business Account, not Personal.</>
      </OrderedList>
    </SetupSection>
    <SetupSection title="Log in to Microsoft to connect integration">
      {connectionContent}
    </SetupSection>
  </>
);
